import type { FC } from "react";
import { Avatar, Stack, Typography } from "@mui/material";

export interface PlatformCardProps {
  platform: {
    title: string;
    url?: string | null;
    logo?: { url?: string | null } | null;
  };
}

export const PlatformCard: FC<PlatformCardProps> = ({ platform }) => {
  if (!platform) {
    return null;
  }

  const placeholderLetter =
    platform.title.trim().slice(0, 1).toUpperCase() || "?";

  return (
    <Stack
      gap={1.5}
      alignItems="center"
      component={platform.url ? "a" : "div"}
      href={platform.url ?? undefined}
      target={platform.url ? "_blank" : undefined}
      rel={platform.url ? "noopener noreferrer" : undefined}
      sx={{
        p: 2,
        pt: 3,
        justifyContent: { lg: "center" },
        textDecoration: "none",
        color: "inherit",
      }}
    >
      <Avatar
        src={platform.logo?.url ?? undefined}
        alt=""
        sx={{
          width: 60,
          height: 60,
          bgcolor: "action.hover",
          color: "text.secondary",
          fontSize: "1.25rem",
          fontWeight: 600,
        }}
      >
        {!platform.logo?.url ? placeholderLetter : null}
      </Avatar>
      <Typography variant="h6" fontWeight={500}>
        {platform.title}
      </Typography>
    </Stack>
  );
};
